import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShare } from "@fortawesome/free-solid-svg-icons";
import chat from "./portfolio/chat.png";
import ultra from "./portfolio/ultra.png";
import weather from "./portfolio/weather.png";
import todolist from "./portfolio/todolist.png";
import portfolio from "./portfolio/portfolio.png";

const Portfolio = () => {
  return (
    <div className="portfolio" id="portfolio">
      <div className="container text-center">
        <h1 className="title">My Work</h1>
        <div className="boxes">
          <div className="box">
            <div className="img">
              <img src={chat}></img>
            </div>
            <p className="lead">Chat Application</p>
            <div className="overlay">
              <a href="https://chatcyborg.netlify.app" target="_blank">
                Open Website{" "}
                <FontAwesomeIcon
                  icon={faShare}
                  className="icon"
                ></FontAwesomeIcon>
              </a>
            </div>
          </div>

          <div className="box">
            <div className="img">
              <img src={weather}></img>
            </div>
            <p className="lead">Weather Application</p>
            <div className="overlay">
              <a href="https://weathersystem.netlify.app" target="_blank">
                Open Website{" "}
                <FontAwesomeIcon
                  icon={faShare}
                  className="icon"
                ></FontAwesomeIcon>
              </a>
            </div>
          </div>

          <div className="box">
            <div className="img">
              <img src={todolist}></img>
            </div>
            <p className="lead">To Do List Application</p>
            <div className="overlay">
              <a href="https://todosystem.netlify.app" target="_blank">
                Open Website{" "}
                <FontAwesomeIcon
                  icon={faShare}
                  className="icon"
                ></FontAwesomeIcon>
              </a>
            </div>
          </div>

          <div className="box">
            <div className="img">
              <img src={ultra}></img>
            </div>
            <p className="lead">Normal Application</p>
            <div className="overlay">
              <a href="https://normalpage.netlify.app" target="_blank">
                Open Website{" "}
                <FontAwesomeIcon
                  icon={faShare}
                  className="icon"
                ></FontAwesomeIcon>
              </a>
            </div>
          </div>
          <div className="box">
            <div className="img">
              <img src={portfolio}></img>
            </div>
            <p className="lead">Amazing Portfolio Application</p>
            <div className="overlay">
              <a href="#">
                Open Website{" "}
                <FontAwesomeIcon
                  icon={faShare}
                  className="icon"
                ></FontAwesomeIcon>
              </a>
            </div>
          </div>
          <div className="box">
            <div className="img">
              <img src={chat}></img>
            </div>
            <p className="lead">Normal Application</p>
            <div className="overlay">
              <a href="#">
                Open Website{" "}
                <FontAwesomeIcon
                  icon={faShare}
                  className="icon"
                ></FontAwesomeIcon>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
